import { Component, OnInit, ViewChild } from '@angular/core';
import { PressService } from '../../../phf.service';
import { PartListService } from '../part-list.service';
import { FilterableService } from '../../../../mesc/filterable-service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'part-search',
  templateUrl: './part-search.component.html',
  styleUrls: ['./part-search.component.scss']
})
export class PartSearchComponent implements OnInit {
  selectedProgram: any;
  selectedPlant: any;
  selectedPlantPresses: any;
  selectedPress: any;
  selectedPartType: any;
  selectedToolSet: any;
  partSearchOption = 0;
  private focused = true;
  toolSetService: FilterableService;
  partTypeService: FilterableService;
  programService: FilterableService;
  plantService: FilterableService = new FilterableService();
  showPressLineDetails: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  @ViewChild('input', { static: false }) vc;

  constructor(
    readonly pressService: PressService,
    readonly partListService: PartListService,
  ) { }

  ngOnInit() {
    this.partTypeService = this.partListService.lookupData.PartTypeViewDto;
    this.plantService = this.partListService.lookupData.PlantViewDto;
    this.programService = this.partListService.lookupData.ProgramViewDto;
    this.toolSetService = this.partListService.lookupData.ToolSetViewDto;


    this.partListService.selectedPlant
      .subscribe(plant => {
        this.selectedPlant = plant;
        if (plant) {
          this.pressService.read('/plant/' + plant.Id)
            .then(x => {
              this.selectedPlantPresses = x;
              x.forEach(p => {
                p.Description = `${p.Number}, Type: ${p.Type}, Class: ${p.Class}`;
                return p;
              });
              x.sort((a,b) => a.Description.localeCompare(b.Description));
              return x;
            });
        }
      });

    this.partListService.selectedProgram
      .subscribe(p => this.selectedProgram = p);

    this.partListService.partType
      .subscribe(p => this.selectedPartType = p);

    this.partListService.toolsetId
      .subscribe(p => this.selectedToolSet = p);

    this.partListService.selectedPress
      .subscribe(p => {
        this.selectedPress = p
      });
  }

  ngAfterViewChecked() {
    if (!this.focused && this.vc) {
      this.vc.nativeElement.focus();
      this.focused = true;
    }
  }


  onKeyUp = (e) => {
    if (isNaN(e.target.valueAsNumber)) {
      try {
        e.target.value = parseInt(e.target.value);
      } catch (e) {
        e.target.value = '';
      }
    }
  }

  handleProgramChange = (dataItem) => {
    if (dataItem !== undefined) {
      this.partListService.selectedProgram.next(this.programService.value.find(x => x.Id === dataItem.Id));
    } else {
      this.partListService.selectedProgram.next(null);
    }
  }

  handlePlantChange = (dataItem) => {
    if (dataItem !== undefined) {
      this.partListService.selectedPlant.next(this.plantService.value.find(x => x.Id === dataItem.Id));
    } else {
      this.partListService.selectedPress.next(null);
    }
  }

  handlePartTypeChange = (dataItem) => {
    if (dataItem !== undefined) {
      this.partListService.partType.next(this.partTypeService.value.find(x => x.Id === dataItem.Id));
    } else {
      this.partListService.partType.next(null);
    }
  }

  handleToolSetChange = (dataItem) => {
    if (dataItem !== undefined) {
      this.partListService.toolsetId.next(this.toolSetService.value.find(x => x.ToolSetId === dataItem.Id));
    } else {
      this.partListService.toolsetId.next(null);
    }
  }

  handlePressChange = (dataItem) => {
    if (dataItem !== undefined) {
      const press = dataItem ? this.selectedPlantPresses.find(x => x.Id === dataItem.Id) : null;
      this.partListService.selectedPress.next(press);
      this.selectedPress = press;
    } else {
      this.partListService.selectedPress.next(null);
      this.selectedPress = null;
    }
  }

  handleTabSelect = ({ index }) => {
    this.partListService.tabIndex = index;
    if (index === 2 || index === 1) this.focused = false;
    if (this.selectedProgram) this.partListService.selectedProgram.next(undefined);
    if (this.selectedPlant) this.partListService.selectedPlant.next(undefined);
    if (this.selectedPress) this.partListService.selectedPress.next(undefined);
    this.selectedProgram = undefined;
    this.selectedPlant = undefined;
    this.selectedPress = undefined;
    this.clearSearch();
  }

  handlePartSearchChange = (index: number) => {
    this.focused = false;
    this.partSearchOption = index;
  }

  handlePartSearch = () => {
    if (this.partSearchOption === 0) {
      this.partListService.partCode.next(this.vc.nativeElement.value);
    }
  }

  getValue = () => {
    if (this.partSearchOption === 0) {
      return this.partListService.partCode.value;
    }
    return null
  }

  toggleSearchBar = () => this.partListService.isCollapsed = !this.partListService.isCollapsed;

  clearSearch = () => {
    if (this.vc) {
      this.vc.nativeElement.value = "";
      if (this.partSearchOption === 0 && this.partListService.partCode.value) {
        this.partListService.partCode.next(null);
      }
    }
  }

  clearAllSearch = () => {
    this.partListService.resetFilters();
  }

  openPressLineDetails() {
    this.showPressLineDetails.next(true);
  }

  closePressLineDetails() {
    this.showPressLineDetails.next(false);
  }
}
